// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".control-button[data-v-7244944c]{position:absolute;width:100%;padding:8px;top:0;z-index:10;display:flex;justify-content:space-between}.mute-button[data-v-7244944c]{cursor:pointer;width:48px;height:48px;background-color:transparent;color:#fff;margin-top:8px;margin-left:8px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
